import React from 'react'
import { useTranslation } from 'i18n'

const sanitizeCustomJSON = stepData => {
  let customJson = JSON.parse(stepData.customJson)
  let videoShareStep = customJson
  return { videoShareStep }
}

const CustomJSONStep = ({
  brk,
  breakId,
  step,
  onEngage = function () {},
  onAwardPoints = function () {},
  userType,
  service,
  nextStepButton,
  themeColors,
  skipButton,
}) => {
  const { t } = useTranslation('customJson')
  const stepSanitized = sanitizeCustomJSON(step)

  return (
    <>
      <section className={`custom-json`}>
        <div
          className={`step-content ${
            brk?.navigationType === 'TOP' ? 'top-navigation' : ''
          } ${stepSanitized.backgroundImage ? ' with-shadow' : ''}`}
        >
          <div className="custom-json__content">
            <p>{t('retiredNotice')}</p>
          </div>
          {skipButton}
          {nextStepButton}
        </div>
      </section>
    </>
  )
}

export default CustomJSONStep
